/* voltage.js — interactions globales du storefront Yamato Gaming.
   Ajout au panier depuis les cartes produit (data-v-add) : AJAX + micro-état « Ajouté »
   + mise à jour du compteur panier du header. Reproduit le comportement de ProductCard.tsx. */
(function () {
  // Garde anti double-initialisation (script chargé deux fois → listeners dupliqués)
  if (window.__voltageAddInit) return;
  window.__voltageAddInit = true;

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-vh-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-hidden', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-v-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var label = btn.querySelector('[data-v-add-label]');
    var original = label ? label.innerHTML : '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        // Réponse non-ok (rupture de stock, variante invalide…) : on ne montre pas « Ajouté »
        if (!r || !r.ok) { btn.dataset.busy = ''; return; }
        refreshCartCount();
        if (label) label.textContent = 'Ajouté';
        setTimeout(function () { if (label) label.innerHTML = original; btn.dataset.busy = ''; }, 1600);
      })
      .catch(function () { btn.dataset.busy = ''; });
  });
})();
